import {
    RequestService,
    RequestServiceResponse,
} from '@tcc-online/request-service';
import { Report } from '@tcc-online/output-report';

const ENDPOINT = '/participant/reports';

const OutputReportService = {
    getReports,
    getReport,
};

async function getReports(): Promise<RequestServiceResponse<Report[]>> {
    return await RequestService.get(ENDPOINT);
}

async function getReport(
    reportId: number,
): Promise<RequestServiceResponse<Report>> {
    return await RequestService.get(`${ENDPOINT}/${reportId}`);
}

export default OutputReportService;
